<template>
  <div>
    <!-- Custom Button Tabs -->
    <!-- <div class="custom-tab-buttons mb-6">
      <v-btn
        :class="['tab-btn', { 'tab-btn--active': dataMappingTab === 0 }]"
        @click="dataMappingTab = 0"
        large
        depressed
      >
        <v-icon left>mdi-file-document-outline</v-icon>
        Sub-case Fields
      </v-btn>
      <v-btn
        :class="['tab-btn', { 'tab-btn--active': dataMappingTab === 1 }]"
        @click="dataMappingTab = 1"
        large
        depressed
      >
        <v-icon left>mdi-account-outline</v-icon>
        Customer Fields
      </v-btn>
    </div> -->

    <!-- Tab Content -->
    <div class="">
      <v-text-field
        v-model="caseType.value"
        label="Subcase Name"
        required
        :rules="caseType.rules"
        :disabled="!!isUploadCase"
        class="mt-4 p-4"
      >
        <template v-slot:append>
          <v-icon @click="openIconSelector" class="cursor-pointer" :loading="iconButtonLoading">
            {{ selectedIcon || 'mdi-help-circle' }}
          </v-icon>
        </template>
      </v-text-field>
      <v-card class="card-shadow">
        <v-card-title class="text-base card-title">
          <v-icon class="mr-2 text-base normal-case" color="primary"
            >mdi-database-cog-outline</v-icon
          >
          Set Data Mapping For Sub-case Fields
        </v-card-title>
        <v-divider></v-divider>
        <v-data-table
          :headers="[
            { text: 'Field Name', value: 'text', width: '25%' },
            { text: 'Mapping Name', value: 'value', width: '45%' },
            { text: 'Visibility', value: 'visibility', width: '15%', align: 'center' },
            { text: 'Required', value: 'required', width: '15%', align: 'center' }
          ]"
          :items="orgKeys"
          :items-per-page="-1"
          hide-default-footer
          disable-sort
          dense
          class="mt-4 p-4"
        >
          <template v-slot:header.visibility>
            <div>Visibility</div>
            <div class="d-flex justify-center align-center w-100">
              <div class="text-center px-4">Form</div>
              <v-divider vertical class="mx-2"></v-divider>
              <div class="text-center px-4">Table</div>
            </div>
          </template>
          <template v-slot:item="{ item }">
            <tr>
              <td class="px-4 font-semibold">
                {{ item.text }}
                <v-menu
                  v-if="item.key === 'caseNo' || item.text === 'Case No'"
                  :close-on-content-click="false"
                  offset-y
                  right
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon x-small v-bind="attrs" v-on="on" class="ml-1">
                      <v-icon x-small color="primary">mdi-cog-outline</v-icon>
                    </v-btn>
                  </template>

                  <v-card min-width="320">
                    <v-card-text class="pa-3">
                      <div class="text-subtitle-2 mb-2">Case No Settings</div>
                      <div class="d-flex align-center  w-full mb-1">
                        <v-text-field
                          v-model="item.selectedPrefix"
                          label="Prefix"
                          outlined
                          dense
                          hide-details
                          class="mr-4"
                          style="max-width: 200px"
                          maxlength="10"
                        ></v-text-field>
                        <v-switch
                          v-model="item.isAutoGenerated"
                          label="Auto"
                          dense
                          hide-details
                          class="mt-0"
                        ></v-switch>
                      </div>
                      <div class="text-caption text-decoration-none font-weight-medium primary--text">
                        Example: {{ (item.selectedPrefix || '') + (item.selectedPrefix ? '_' : '') + '20260525_223053' }}
                      </div>
                    </v-card-text>
                  </v-card>
                </v-menu>
              </td>
              <td class="py-2">
                <div class="d-flex align-center">
                  <v-text-field
                    v-model="item.value"
                    dense
                    :label="`Display Name of ${item.text}`"
                    :disabled="!!isUploadCase"
                    hide-details
                    outlined
                  ></v-text-field>
                </div>
              </td>
              <td>
                <div class="d-flex justify-center align-center">
                  <div class="d-flex justify-center" style="width: 50%">
                    <v-checkbox
                      v-model="item.formVisibility"
                      dense
                      hide-details
                      @change="updateVisibility(item)"
                    ></v-checkbox>
                  </div>
                  <v-divider vertical></v-divider>
                  <div class="d-flex justify-center" style="width: 50%">
                    <v-checkbox
                      v-model="item.tableVisibility"
                      dense
                      hide-details
                      @change="updateVisibility(item)"
                    ></v-checkbox>
                  </div>
                </div>
              </td>
              <td class="text-center px-4">
                <v-checkbox v-model="item.required" dense hide-details></v-checkbox>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
      <v-divider class="my-4"></v-divider>

      <v-card-title class="text-base card-title">
        <v-icon class="mr-2 text-base normal-case" color="primary">mdi-database-cog-outline</v-icon>
        Custom Fields
      </v-card-title>

      <v-data-table
        :headers="[
          { text: 'Field Name', value: 'text', width: '30%' },
          { text: 'Type / Options', value: 'value', width: '30%' },
          { text: 'Visibility', value: 'visibility', width: '20%', align: 'center' },
          { text: 'Required', value: 'required', width: '10%', align: 'center' },
          { text: 'Actions', value: 'actions', width: '10%' }
        ]"
        :items="extraColumns"
        :items-per-page="-1"
        hide-default-footer
        disable-sort
        dense
        class="p-4"
      >
        <template v-slot:header.visibility>
          <div>Visibility</div>
          <div class="d-flex justify-center align-center w-100">
            <div class="text-center px-4">Form</div>
            <v-divider vertical class="mx-2"></v-divider>
            <div class="text-center px-4">Table</div>
          </div>
        </template>
        <template v-slot:item="{ item, index }">
          <tr>
            <td class="px-2 py-1">
              <v-text-field v-model="item.text" dense hide-details outlined></v-text-field>
            </td>
            <td class="py-2">
              <v-select
                v-model="item.value"
                :items="getFilteredItems(index)"
                dense
                hide-details
                outlined
              ></v-select>
              <v-text-field
                v-if="item.value && item.value.includes('SELECT')"
                v-model="item.options"
                placeholder="Options (e.g. Low, Medium, High)"
                dense
                hide-details
                outlined
                class="mt-2"
              >
                <template v-slot:append>
                  <v-btn x-small text color="primary" @click="saveOptions(item)" class="mb-1">
                    Save Options
                  </v-btn>
                </template>
              </v-text-field>
            </td>
            <td>
              <div class="d-flex justify-center align-center">
                <div class="d-flex justify-center" style="width: 50%">
                  <v-checkbox
                    v-model="item.formVisibility"
                    dense
                    hide-details
                    @change="updateVisibility(item)"
                  ></v-checkbox>
                </div>
                <v-divider vertical></v-divider>
                <div class="d-flex justify-center" style="width: 50%">
                  <v-checkbox
                    v-model="item.tableVisibility"
                    dense
                    hide-details
                    @change="updateVisibility(item)"
                  ></v-checkbox>
                </div>
              </div>
            </td>
            <td class="text-center px-4">
              <v-checkbox v-model="item.required" dense hide-details></v-checkbox>
            </td>
            <td class="px-4">
              <v-btn icon small color="error" @click="removeExtraColumn(index)">
                <v-icon small>mdi-delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>

      <div class="flex justify-end">
        <v-btn
          color="primary"
          text
          small
          outlined
          class="mt-2 normal-case"
          @click="addExtraColumn"
          v-if="!isUploadCase"
        >
          <v-icon left small>mdi-plus</v-icon>
          Add Custom Field
        </v-btn>
      </div>
      <!-- Icon Selector Dialog -->
      <IconSelector
        v-model="showIconSelector"
        :current-icon="currentIcon"
        :icons="apiIcons"
        :loading="iconSelectorLoading"
        @icon-selected="onIconSelected"
        @cancelled="onIconSelectorCancelled"
      />
    </div>

    <v-divider class="mt-4"></v-divider>
    <div class="mt-4">
      <v-card-title class="pb-2 text-base card-title">
        <v-icon class="mr-2 text-base normal-case" color="primary">mdi-database-cog-outline</v-icon>
        Set Data Mapping For Customer Fields
      </v-card-title>
      <v-card class="pl-4" flat>
        <v-card-text class="card-title">
          <div class="d-flex flex-wrap">
            <v-text-field
              v-model="staticFields.crn"
              label="CRN No"
              required
              :rules="staticFields.crnRules"
              :disabled="!!isUploadCase"
              class="mr-4"
              outlined
              dense
              style="width: 200px"
            ></v-text-field>
            <v-text-field
              v-model="staticFields.customerFullName"
              label="Customer Name"
              required
              :rules="staticFields.customerFullNameRules"
              :disabled="!!isUploadCase"
              class="mr-4"
              outlined
              dense
              style="width: 200px"
            ></v-text-field>
            <v-text-field
              v-model="staticFields.customerMobile"
              label="Mobile"
              :disabled="!!isUploadCase"
              class="mr-4"
              style="width: 200px"
              outlined
              dense
            ></v-text-field>
            <v-text-field
              v-model="staticFields.customerEmail"
              label="Email"
              :disabled="!!isUploadCase"
              style="width: 200px"
              outlined
              dense
            ></v-text-field>
          </div>

          <v-expansion-panels class="mt-4" flat>
            <v-expansion-panel v-for="(address, index) in addresses" :key="index" class="border">
              <v-expansion-panel-header>
                <div class="d-flex align-center">
                  <span>Address {{ index + 1 }}</span>
                  <v-chip x-small label class="ml-2" :color="address.default ? 'primary' : 'grey'">
                    {{ address.typeOfAddress || 'Select Type' }}
                  </v-chip>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="d-flex justify-between align-center mb-4">
                  <v-select
                    v-model="address.typeOfAddress"
                    :items="getFilteredAddressTypes(index)"
                    label="Type"
                    :disabled="!!isUploadCase"
                    class="mr-4"
                    style="max-width: 300px"
                    outlined
                    dense
                    hide-details
                  ></v-select>
                  <v-checkbox
                    v-model="address.default"
                    label="Set as default"
                    @change="setDefault(index)"
                    class="mr-4"
                  ></v-checkbox>
                  <v-btn
                    icon
                    small
                    color="error"
                    @click="removeAddress(index)"
                    v-show="addresses.length > 1"
                  >
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </div>

                <div class="d-flex flex-wrap">
                  <v-text-field
                    v-for="(field, key) in addressFields"
                    :key="key"
                    v-model="address[key].displayName"
                    :label="field.text"
                    :disabled="!!isUploadCase"
                    class="mr-4 mb-4"
                    style="width: 200px"
                    @input="validateAddress"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <div class="flex justify-end mt-4">
            <v-btn
              color="primary"
              text
              small
              outlined
              @click="addAddress"
              v-show="addresses.length < addressTypes.length"
            >
              <v-icon left small>mdi-plus</v-icon>
              Add Address
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import IconSelector from '@/components/common/IconSelector.vue'

export default {
  name: 'DataMapping',
  components: {
    IconSelector
  },
  props: {
    caseType: {
      type: Object,
      required: true
    },
    orgKeys: {
      type: Array,
      required: true
    },
    extraColumns: {
      type: Array,
      required: true
    },
    staticFields: {
      type: Object,
      required: true
    },
    addresses: {
      type: Array,
      required: true
    },
    addressFields: {
      type: Object,
      required: true
    },
    addressTypes: {
      type: Array,
      required: true
    },
    selectedAmountKey: {
      type: String,
      default: null
    },
    isUploadCase: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dataMappingTab: 0,
      // Icon selector properties
      showIconSelector: false,
      currentIcon: '',
      selectedIcon: this.caseType?.icon || '',
      iconSelectorLoading: false,
      iconButtonLoading: false,
      apiIcons: [],
      iconsLoaded: false,
      loadingIcons: false,
      popoverMenu: {}
    }
  },
  methods: {
    saveOptions(item) {
      if (item.options) {
        this.$toast.success(`Options for ${item.text} updated. They will be saved with the data mapping.`)
      } else {
        this.$toast.warning('Please enter some options first.')
      }
    },
    updateVisibility(item) {
      item.visibility = item.formVisibility || item.tableVisibility
      this.$emit('update-visibility', item)
    },
    getFilteredItems(index) {
      const search = this.extraColumns[index].search || this.extraColumns[index].text
      if (search) {
        const baseItems = ['STRING', 'NUMBER', 'DATE', 'CURRENCY', 'SELECT']
        return baseItems.map((type) => ({
          text: `${search} - ${type}`,
          value: `${search} - ${type}`
        }))
      }
      return []
    },
    removeExtraColumn(index) {
      this.$emit('remove-extra-column', index)
    },
    addExtraColumn() {
      this.$emit('add-extra-column')
    },
    getFilteredAddressTypes(currentIndex) {
      const selectedTypes = this.addresses
        .filter((_, index) => index !== currentIndex)
        .map((address) => address.typeOfAddress)

      return this.addressTypes.filter((type) => !selectedTypes.includes(type))
    },
    removeAddress(index) {
      this.$emit('remove-address', index)
    },
    addAddress() {
      this.$emit('add-address')
    },
    setDefault(index) {
      this.$emit('set-default-address', index)
    },
    validateAddress() {
      this.$emit('validate-address')
    },
    setDefaultPrefixSuffix() {
      if (this.orgKeys) {
        this.orgKeys.forEach((item) => {
          if (item.prefix && item.prefix.length) {
            item.selectedPrefix = '₹'
          }
          if (item.suffix && item.suffix.length) {
            item.selectedSuffix = 'Weekly'
          }
        })
      }
    },
    // Icon selector methods
    openIconSelector() {
      // Set loading state for this specific button
      this.iconButtonLoading = true

      // Show dialog immediately with loading state
      this.showIconSelector = true

      // Check if icons are already loaded to prevent redundant API calls
      if (this.iconsLoaded && this.apiIcons.length > 0) {
        this.iconSelectorLoading = false
        this.iconButtonLoading = false
      } else if (!this.loadingIcons) {
        // Show loading state in dialog
        this.iconSelectorLoading = true
        // Only fetch if not already loading
        this.fetchApiIcons()
          .then(() => {
            this.iconSelectorLoading = false
            this.iconButtonLoading = false
          })
          .catch(() => {
            this.iconSelectorLoading = false
            this.iconButtonLoading = false
          })
      } else {
        // Already loading, show loading state
        this.iconSelectorLoading = true
        // Wait for existing loading to complete
        const checkLoading = () => {
          if (!this.loadingIcons) {
            this.iconSelectorLoading = false
            this.iconButtonLoading = false
          } else {
            setTimeout(checkLoading, 100)
          }
        }
        checkLoading()
      }
    },

    onIconSelected(selectedIcon) {
      this.selectedIcon = selectedIcon.icon
      this.showIconSelector = false
      this.currentIcon = ''

      // Emit the selected icon to parent component
      this.$emit('icon-selected', selectedIcon.icon)
    },

    onIconSelectorCancelled() {
      this.showIconSelector = false
      this.currentIcon = ''
      this.iconButtonLoading = false
    },

    async fetchApiIcons() {
      // Early return if icons are already loaded or currently loading
      if (this.iconsLoaded || this.loadingIcons) {
        return Promise.resolve()
      }

      this.loadingIcons = true
      try {
        const res = await this.$axios.get('/mdi-icons')
        if (res.data && res.data.data && Array.isArray(res.data.data.i)) {
          this.apiIcons = res.data?.data?.i.map((icon) => {
            return {
              text: icon.n,
              icon: `mdi-${icon.n}`
            }
          })
          this.iconsLoaded = true // Mark as loaded to prevent future calls
        } else {
          throw new Error('Invalid API response format')
        }
      } catch (error) {
        console.error('Error fetching API icons:', error)
        this.$toast.error('Failed to load icons. Please try again.')
        throw error // Re-throw to handle in calling function
      } finally {
        this.loadingIcons = false
      }
    }
  },
  watch: {
    orgKeys: {
      handler() {
        this.setDefaultPrefixSuffix()
      },
      immediate: true
    },
    caseType: {
      handler(newVal) {
        if (newVal && newVal.icon) {
          this.selectedIcon = newVal.icon
        }
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style scoped>
.custom-tab-buttons {
  display: flex;
  gap: 8px;
  padding: 6px;
  background-color: #f8f9fa;
  border-radius: 12px;
  border: 1px solid #e9ecef;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.tab-btn {
  flex: 1;
  height: 48px !important;
  border-radius: 8px !important;
  font-weight: 500 !important;
  text-transform: none !important;
  letter-spacing: normal !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  background-color: transparent !important;
  color: #6c757d !important;
  border: 1px solid transparent !important;
  box-shadow: none !important;
}
.card-shadow {
  box-shadow: none !important;
}

.tab-btn:hover {
  background-color: rgba(13, 110, 253, 0.08) !important;
  color: #0d6efd !important;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(13, 110, 253, 0.15) !important;
}

.tab-btn--active {
  background-color: #0d6efd !important;
  color: white !important;
  border: 1px solid #0d6efd !important;
  box-shadow: 0 4px 12px rgba(13, 110, 253, 0.3) !important;
  transform: translateY(-2px);
}

.tab-btn--active:hover {
  background-color: #0b5ed7 !important;
  color: white !important;
  transform: translateY(-2px);
}

.tab-btn--active .v-icon {
  color: white !important;
}

.tab-btn .v-icon {
  color: inherit !important;
  margin-right: 8px;
}

/* Remove default button styles */
.tab-btn::before {
  display: none !important;
}

.tab-btn .v-btn__content {
  font-size: 14px;
  font-weight: 500;
}
.card-title {
  padding-left: 0px !important;
  padding: 16px !important;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
